import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Chat order: newest row last, the view starts at the bottom and older rows load above.
export default class FeedAnchorToBottom extends BaseOption {
  static userInterfaceComponent = {
    label: "Newest at bottom",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage: "Show the newest row last and open the feed at the bottom, like a chat.",
    props: {
      options: [
        { label: "On", value: true, tooltip: "" },
        { label: "Off", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
